import { Box } from '@mui/material'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Datepicker from '../../../common/datePicker'
import DropDownOA from '../../../common/dropDownOA'
import { appendToUrl, focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from '../common/ReportHeading'
import * as id from '../reportId'
import * as lb from '../reportLables'
import * as reportUrls from '../oldReportsUrls'
import moment from 'moment/moment'
import { API_CACHE_DURATION, paymentModeAll, urls } from '../../../common/constants'
import { paymentModesWithAll, paytypes, TOPAY_COD_RULE } from '../../../common/paymentsMode'
import { useAtom, useAtomValue, useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom, modalAtom } from '../../../common/jotaiState/globalStateAtoms'
import { GetRequest, GetRequestCachedV3 } from '../../../common/api'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import DropDownMultiSelectV2 from '../../../common/dropDownMultiSelectV2'
import LoaderModel from './loaderModel'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../common/jotaiState/reportStateAtom'
import { ReportTable } from './reportTable'
import useToken from '../../../helpers/useTokens'
import { GT_COMPANY_ID, PAYAL } from '../../../../helper/companyIdhardcode'
const transactionsData = [
  { Transactions: 'All', transactionId: 0 },
  { Transactions: 'Booking', transactionId: 1 },
  { Transactions: 'Delivery', transactionId: 2 },
  { Transactions: 'Refund', transactionId: 3 },
]
const ModesData = [0, 'B', 'D', 'R']
const reportViewData = [
  { view: 'Detailed', id: 0 },
  { view: 'Summary', id: 1 },
  { view: 'Summary-UserWise', id: 2 },
]
const UserWiseCollection = () => {
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  const companySettings = useAtomValue(companySettingsAtom)
  const { UseToPayAsCOD, DefaultCurrencyID } = companySettings || {}
  const updatedPaymentModes = !UseToPayAsCOD
    ? paymentModesWithAll
    : paymentModesWithAll
        .map((item) => {
          if (item.typeId === paytypes.COD) return null
          const codName = TOPAY_COD_RULE[item.typeId]
          return codName ? { ...item, name: codName } : item
        })
        .filter(Boolean)
  const roleRights = useAtomValue(CargoRoleRightsAtom)
  const reportName = 'User Wise Collection'
  const { loginData } = useToken()
  const { intUserID, intCompanyID, intBranchID, strCompanyName, strBranchName } = loginData
  const { IsBranchAdmin, IsMTPLAdmin, IsAdmin } = loginData
  const RoleRights = roleRights?.Table1?.[0] || {}
  const { AllowViewAllBranchReport, AllowBranchInchargeRights, AllowExportExcel, AllowViewAllBranchOfCityReport,AllowPrintandPdf = 1  } = RoleRights
  const [selCompany, setSelCompany] = useState(false)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selBranch, setSelBranch] = useState()
  const [selUser, setSelUser] = useState([])
  const [userStatusList, setUserStatusList] = useState([])
  const [transaction, setTransaction] = useState(transactionsData[0])
  const [paymentType, setPaymentType] = useState(updatedPaymentModes[0])
  const [paymentMode, setPaymentMode] = useState(paymentModeAll)
  const [paymentModeData, setPaymentModeData] = useState([])
  const [reportView, setReportView] = useState(reportViewData?.[0])
  const [showTable, setShowTable] = useState(false)
  const [ownChildBranches, setOwnChildBranches] = useState([])
  const [ownChildUsers, setOwnChildUsers] = useState([])
  const [modal, setModal] = useAtom(modalAtom)
  const [userWiseCollection, setUserWiseCollection] = useState({})
  const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
  const [ChildCompanyList] = useAtom(ChildCompanyListData)
  const { AllowGroupofCompanies = 0 } = roleRights?.Table1?.[0] || {}
  const disableBtn = !(AllowViewAllBranchReport || AllowBranchInchargeRights || IsBranchAdmin || IsMTPLAdmin || IsAdmin)
  const disableExcel = !AllowExportExcel

  useEffect(() => {
    if (AllowGroupofCompanies === 1) {
      const defaultCompany = ChildCompanyList.find((v) => v.CompanyID === intCompanyID) || ChildCompanyList[0]
      setSelCompany(defaultCompany)
    } else {
      setSelCompany({
        CompanyID: intCompanyID,
        CompanyName: strCompanyName,
      })
    }
  }, [ChildCompanyList, AllowGroupofCompanies])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const body = {
        intCompanyID: intCompanyID,
        UserID: intUserID,
      }
      fetchChildCompanyList(body)
    }
  }, [loginData])
  useEffect(() => {
    focusElemnt('UWFromDate')
  }, [])
  useEffect(() => {
    if (intUserID) {
      const branchData = {
        intUserID,
        intCompanyID,
        intIsActive: -1,
      }
      getBranchData(branchData, true, API_CACHE_DURATION)
      getUserData(branchData, true, API_CACHE_DURATION)
      getPaymentModeData({ intBranchID }, true, API_CACHE_DURATION)
    }
  }, [intUserID])
  useEffect(() => {
    if (selUser.length) {
      setUserStatusList(
        selUser.map((val) => ({
          loaded: 0,
          data: [],
          UserID: val.UserID,
          UserName: val.UserName,
        }))
      )
    }
  }, [selUser])

  const getBranchData = async (data, isCache, cacheDuration) => {
    setLoader(true)
    const res = await GetRequestCachedV3(urls.getOwnAndChildBranchList, data, isCache, cacheDuration)
    setLoader(false)
    if (res?.status === 'Success' && res?.Data?.Table?.length > 0) {
      setOwnChildBranches(res.Data.Table)
      setSelBranch(res.Data.Table.find((val) => val.BranchID === intBranchID) || res.Data.Table[0])
    } else {
      setAlert({ show: true, msg: res?.ErrMessage })
      setOwnChildBranches([])
    }
  }
  const getUserData = async (data, isCache, cacheDuration) => {
    setLoader(true)
    const res = await GetRequestCachedV3(urls.getOwnAndChildUsersList, data, isCache, cacheDuration)
    setLoader(false)
    if (res?.status === 'Success' && res?.Data?.Table?.length > 0) {
      setOwnChildUsers(res.Data.Table)
      setSelUser(res.Data.Table.filter((val) => val.UserID === intUserID) || [])
    } else {
      setOwnChildUsers([])
      setAlert({ show: true, msg: res?.ErrMessage })
    }
  }
  const getPaymentModeData = async (data, isCache, cacheDuration) => {
    setLoader(true)
    const res = await GetRequestCachedV3(urls.getMOFPayment, data, isCache, cacheDuration)
    setLoader(false)
    if (res?.status === 'Success' && res?.Data?.Table?.length > 0) {
      setPaymentModeData([paymentModeAll, ...res.Data.Table])
    } else {
      setPaymentModeData([])
      setAlert({ show: true, msg: res?.ErrMessage })
    }
  }
  const getReportData = async (data) => {
    const res = await GetRequest(urls.getUserWiseCollection, data)
    if (res?.status === 'Success') {
      const updatedData = { ...res.Data }
      if (UseToPayAsCOD === 1 && Array.isArray(updatedData.Table)) {
        updatedData.Table = updatedData.Table.map((item) => ({
          ...item,
          TYPE: TOPAY_COD_RULE[item.PaymentTypeInt] || item.TYPE,
        }))
      }
      return updatedData
    } else {
      setAlert({ show: true, msg: res?.ErrMessage })
      return []
    }
  }
  const handleClick2 = () => {
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      let url = reportUrls.userWiseCollection
      const urlData = reportUrls.userWiseCollectionParams
      urlData.chk = loginData.BusCrsCheckSum
      urlData.FromDt = fromDate.format('YYYY-MM-DD')
      urlData.ToDt = toDate.format('YYYY-MM-DD')
      urlData.BranchID = selBranch.BranchID
      urlData.UserID = selUser.UserID
      urlData.Summary = reportView?.id
      urlData.TransType = transaction.transactionId
      urlData.PaymentMode = paymentMode?.ModeID
      urlData.intCargoParentCompanyID = loginData?.intCompanyID
      url = appendToUrl(url, urlData)
      window.open(url, '_blank')
    }
  }
  const handleClick1 = async () => {
    setUserWiseCollection({})
    if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      if (selUser === '' || selUser === ' ') {
        setAlert({ show: true, msg: 'Select Company User', nextId: '' })
      } else {
        if (selUser.length === 1 || selUser[0].UserID === 0) {
          const obj = {
            CompanyID: selCompany?.CompanyID,
            BranchID: selBranch?.BranchID,
            UserID: selUser[0].UserID,
            dtFrom: moment(fromDate).format('YYYY-MM-DD'),
            dtTo: moment(toDate).format('YYYY-MM-DD'),
            PaymentTypeIDs: paymentType?.typeId,
            Modes: ModesData[transaction?.transactionId],
            PaymentModeIDs: paymentMode?.ModeID,
          }
          setLoader(true)
          const reportData = await getReportData(obj)
          setLoader(false)
          setUserWiseCollection(reportData)
          setShowTable(true)
        } else if (selUser.length > 1) {
          const obj = {
            CompanyID: selCompany?.CompanyID,
            BranchID: selBranch?.BranchID,
            UserID: selUser[0].UserID,
            dtFrom: moment(fromDate).format('YYYY-MM-DD'),
            dtTo: moment(toDate).format('YYYY-MM-DD'),
            PaymentTypeIDs: paymentType?.typeId,
            Modes: ModesData[transaction?.transactionId],
            PaymentModeIDs: paymentMode?.ModeID,
          }
          setModal('loaderModal')
          const reportDataList = []
          for (let i = 0; i < selUser.length; i++) {
            const UserID = selUser[i].UserID
            setUserStatusList((prevList) => prevList.map((item) => (item.UserID === UserID ? { ...item, loaded: 1 } : item)))
            const reportData = await getReportData({ ...obj, UserID })
            setUserStatusList((prevList) => prevList.map((item) => (item.UserID === UserID ? { ...item, loaded: 2 } : item)))
            reportDataList.push(reportData)
          }
          const { Table, Table1, Table3,Table4 } = reportDataList.reduce(
            (acc, curr) => {
              if (curr.Table) acc.Table.push(...curr.Table)
              if (curr.Table1) acc.Table1.push(...curr.Table1)
              if (curr.Table3) acc.Table3.push(...curr.Table3)
              if (curr.Table4) acc.Table4.push(...curr.Table4)
              return acc
            },
            { Table: [], Table1: [], Table3: [], Table4: [] }
          )
          const Table3Sum = Table3.reduce(
            (acc, item) => {
              acc.TotalConvCharge += parseFloat(item.TotalConvCharge) || 0
              acc.TotalLRs += parseFloat(item.TotalLRs) || 0
              acc.TotalUnis += parseFloat(item.TotalUnis) || 0
              return acc
            },
            {
              TotalConvCharge: 0,
              TotalLRs: 0,
              TotalUnis: 0,
            }
          )
          setUserWiseCollection({
            Table,
            Table1,
            Table2: reportDataList[0].Table2,
            Table3: [Table3Sum],
            Table4,
          })
          setShowTable(true)
          setModal()
        }
      }
    }
  }
  const reset = () => {
    setFromDate(moment(new Date()))
    setToDate(moment(new Date()))
    setSelBranch({ BranchName: strBranchName, BranchID: intBranchID })
    setSelUser([])
    setTransaction(transactionsData[0])
    setPaymentType(updatedPaymentModes?.[0])
    setPaymentMode(paymentModeAll)
    setReportView(reportViewData?.[0])
    setShowTable(false)
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              id={id.selectCompnay}
              label={lb.select_company}
              data={ChildCompanyList}
              defaultvalue={selCompany?.CompanyName}
              disabled={AllowGroupofCompanies === 1 ? false : true}
              onSelect={(e) => {
                setSelCompany(e)
                setShowTable(false)
              }}
              dataKey={`CompanyName`}
              idKey={`CompanyID`}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={lb.from_collection_date}
              id={'UWFromDate'}
              dateChange={(date) => {
                setFromDate(date)
                setShowTable(false)
                focusElemnt('UWToDate')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
            <Datepicker
              label={lb.to_collection_date}
              value={toDate}
              id={'UWToDate'}
              dateChange={(date) => {
                setToDate(date)
                setShowTable(false)
                focusElemnt(id.selBranch)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              label={lb.select_branch}
              id={id.selBranch}
              data={
                AllowViewAllBranchOfCityReport == 1 && AllowViewAllBranchReport == 0
                  ? ownChildBranches.filter((val) => val.CityID == loginData?.intBranchCityID)
                  : ownChildBranches || []
              }
              defaultvalue={(ownChildBranches?.length > 0 && selBranch?.BranchName) || ''}
              disabled={disableBtn && AllowViewAllBranchOfCityReport == 0}
              dataKey={`BranchName`}
              idKey={`BranchID`}
              onSelect={(val) => {
                setSelBranch(val)
                setShowTable(false)
                setSelUser([])
              }}
              width="100%"
              nextId={id.userLIst}
              prevId={'UWToDate'}
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownMultiSelectV2
              id={id.userLIst}
              label={'Branch User'}
              defaultvalue={selUser}
              data={[{UserName: 'All Users', UserID: 0},...ownChildUsers?.filter((val) => val?.BranchID === selBranch?.BranchID && val?.IsUserActive)]}
              dataKey={`UserName`}
              idKey={`UserID`}
              onSelect={(list) => {
                setSelUser(list)
                setShowTable(false)
              }}
              HasAllSelect={true}
              nextId={'UWTransaction'}
              prevId={id.selBranch}
              disabled={[GT_COMPANY_ID , PAYAL].includes(loginData.intCompanyID)?false:disableBtn && AllowViewAllBranchOfCityReport === 0}
            />
          </Item>
        </Box>
        <Box sx={{ ...sx.reportFlex }}>
          <Item sx={sx.itemsx} style={{ width: '170px' }}>
            <DropDownOA
              id={'UWTransaction'}
              defaultvalue={transaction?.Transactions}
              data={transactionsData}
              width="100%"
              searchPlaceholder={`Search Transactions`}
              label={'Transaction Type'}
              tabIndex="2"
              dataKey={`Transactions`}
              idKey={`transactionId`}
              onSelect={(value) => {
                setTransaction(value)
                setShowTable(false)
              }}
              nextId={'UWPaymentType'}
              prevId={id.userLIst}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '175px' }}>
            <DropDownOA
              id="UWPaymentType"
              data={updatedPaymentModes}
              defaultvalue={paymentType?.name}
              width="100%"
              searchPlaceholder={`Search By Payment Type`}
              label={'Payment Type'}
              tabIndex="2"
              dataKey={`name`}
              idKey={`typeId`}
              onSelect={(value) => {
                setPaymentType(value)
                setShowTable(false)
              }}
              nextId={'UWPaymentMode'}
              prevId={'UWTransaction'}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '270px' }}>
            <DropDownOA
              id="UWPaymentMode"
              data={paymentModeData}
              defaultvalue={paymentModeData?.length > 0 && paymentMode?.ModeName}
              width="100%"
              searchPlaceholder={`Search By Payment Mode`}
              label={'Payment Mode'}
              tabIndex="2"
              dataKey={`ModeName`}
              idKey={`ModeID`}
              onSelect={(value) => {
                setPaymentMode(value)
                setShowTable(false)
              }}
              nextId={'UWReportView'}
              prevId={'UWPaymentType'}
            />
          </Item>
          <Item sx={sx.itemsx} style={{ width: '268px' }}>
            <DropDownOA
              id="UWReportView"
              defaultvalue={reportView?.view}
              data={DefaultCurrencyID === 2 ? reportViewData.filter(val => val.id !== 2) : reportViewData}
              width="100%"
              searchPlaceholder={`Search By View`}
              label={'Report View'}
              tabIndex="2"
              dataKey={`view`}
              idKey={`id`}
              onSelect={(value) => {
                setReportView(value)
                setShowTable(false)
              }}
              nextId={'UWSplitButton'}
              prevId={'UWPaymentMode'}
            />
          </Item>
          <Item
            sx={sx.itemsx}
            style={{ cursor: 'pointer' }}
            onKeyDown={(e) =>
              navigation3(e, showTable ? (disableExcel ? 'UWExpToPdfBtn' : 'UWExpToExsl') : 'UWFromDate', 'UWReportView', () =>
                handleClick1()
              )
            }
          >
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
              // hideToggle={true}

              id1={'UWSplitButton'}
              prevID={id.summaryCheck}
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
            <RefreshSvg width={'24px'} height={'24px'} />
          </Item>
        </Box>
      </Item>
      <Item>
        {showTable ? (
          <ReportTable
            AllowPrintandPdf={AllowPrintandPdf}
            disableExcel={disableExcel}
            userDetail={userWiseCollection?.Table2 || []}
            tableData={userWiseCollection?.Table || []}
            tableData1={userWiseCollection?.Table1 || []}
            tableData2={userWiseCollection?.Table3 || []}
            tableData4={userWiseCollection?.Table4 || []}
            isSummary={reportView?.id === 1}
            isSummaryUserWise={reportView?.id === 2}
            loginData={loginData}
            reportView={reportView}
            fromDate={fromDate}
            toDate={toDate}
            selBranch={selBranch}
            UserName={selUser.length === 1 ? selUser[0].UserName : 'All'}
            transaction={transaction}
            paymentMode={paymentMode}
            paymentType={paymentType}
          />
        ) : (
          ''
        )}
      </Item>
      {modal === 'loaderModal' && <LoaderModel list={userStatusList} />}
    </>
  )
}
export default UserWiseCollection
